import { createApp } from '@invisible/common/providers'

import { Layout } from '../common/components/Layout'

export default createApp({ Layout })
